import React, { useCallback, useEffect } from "react";
import { observer } from "mobx-react";

import { HStack } from "@formant/ui/component/common/HStack";

import { useStores } from "../../../context/StoreContext";
import { ITeleopSession } from "../../../teleop/ITeleopSession";
import { Accordion } from "../../common/Accordion";
import { IconButton } from "../../common/IconButton";
import styles from "./index.scss";
import { TerminalWindow } from "./TerminalWindow";

const terminalEntryMessage = `    \u001b[30;1mWelcome to your device's terminal. This \r
    session is running as the \u001b[37mformant\u001b[30;1m user. \r
    Have fun! 🤖\r\n\r\n`;

const terminalOnboardingMessage = `    \u001b[30;1mYou've successfully connected to your device and can now\r
    access it's terminal! This session is running as the \u001b[37mformant\u001b[30;1m\r
    user. When you're ready to setup video hit the X button\r
    in the top right corner! 🤖\r\n\r\n`;

export interface ITerminalViewProps {
    session: ITeleopSession;
    onboarding: boolean;
}

export const TerminalView = observer(function TerminalView(
    props: ITerminalViewProps,
) {
    const { onboarding, session } = props;
    const { operateStore } = useStores();
    const { usingTerminal } = operateStore;

    const closeTerminal = useCallback(() => {
        operateStore.usingTerminal = false;
    }, [operateStore]);

    useEffect(() => closeTerminal, [closeTerminal]);

    return (
        <Accordion
            visible={usingTerminal}
            className={styles.terminal}
            maxHeight="48vh"
        >
            <HStack hAlign="end" className={styles.header}>
                <IconButton icon="chevron-up" onClicked={closeTerminal} />
            </HStack>
            <TerminalWindow
                session={session}
                startMessage={
                    onboarding
                        ? terminalOnboardingMessage
                        : terminalEntryMessage
                }
            />
        </Accordion>
    );
});
